import { BcsFlag, FcsFlag } from "../unleash";

/* eslint-disable @typescript-eslint/camelcase */
const FcsPermissionHandover = {
  handover_enable: new FcsFlag.Flag(false),
  handover_create: new FcsFlag.Flag(false),
  handover_detail_view: new FcsFlag.Flag(false),
  handover_scan_first_revamp: new FcsFlag.Flag(false)
};

const BcsPermissionHandover = {
  config_max_scan_handover_v2: new BcsFlag.NumberFlag(100)
};

export const FlagsPermissionHandover = {
  ...FcsPermissionHandover,
  ...BcsPermissionHandover
};

export function initFlagsPermissionHandover() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureHandover", FcsPermissionHandover);
  BcsFlag.register("featureHandover", BcsPermissionHandover);
}
